"use client"

import { useEffect, useRef } from "react"
import { useSearchParams } from "next/navigation"

import { trackBillingCheckoutReturn } from "@/lib/analytics/billing-analytics"

export function BillingCheckoutAnalytics() {
  const params = useSearchParams()
  const done = useRef(false)

  useEffect(() => {
    if (done.current) return
    const checkout = params.get("checkout")?.trim()
    if (checkout !== "success" && checkout !== "cancel") return
    const key = `billing_co_${checkout}`
    try {
      if (sessionStorage.getItem(key)) {
        done.current = true
        return
      }
      sessionStorage.setItem(key, "1")
    } catch {
      // ignore
    }
    trackBillingCheckoutReturn(checkout)
    done.current = true
  }, [params])

  return null
}
